export default __webpack_public_path__ + "static/media/two.87867d57.png";